import type { ReactNode } from 'react';

export const symbol_ssid_chart: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M120-338.28q0-7.72 3.5-13.22Q127-357 133-362l65-47q18-13 39.66-11.1 21.66 1.9 37.34 17.1l209 203 156-124q7.94-5.78 16.97-9.39Q666-337 677-337h133q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H676L522-153q-18 14-40 13t-39-17L233-360l-66 47q-15 11-31 2.51t-16-27.79ZM120-605q0-7.5 3-13.5t9-10.5l139-101q18-13 39.66-11.48Q332.32-739.96 348-724l139 139 306-221q15-11 31-2.51t16 27.79q0 7.72-3 13.22-3 5.5-9 10.5L522-536q-18 13-39.66 11.48Q460.68-526.04 445-542L306-681 167-580q-15 11-31 2.57-16-8.42-16-27.57Z"
		/>
	</svg>
);
